// extracted by mini-css-extract-plugin
export default {"section":"SQHLnn","title":"QzfHgP"};